module.exports = __webpack_public_path__ + "img/ydm.82b20aa8.png";